<template>
    <div class="page-blocked__wrapper mt-5">
        <div class="page-blocked__content">
            <img :src="LockImage" alt="Lock" />
            <p v-if="title" v-html="title">
            </p>
            <p v-else>
                This is a {{ blockRole }}members-only feature. To learn more about Clowder Membership,
                <a href="https://www.clowder.com" target="_blank">click here</a>
            </p>
        </div>
    </div>
</template>
<script>
import LockImage from '@/assets/images/lock.svg'
import { mapGetters } from 'vuex';
export default {
    props: {
        blockRole: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            LockImage
        }
    },
    computed: {
        ...mapGetters('settings', ['appCore']),

        title() {
            return this.appCore?.menu_block_screen
        }
    }
}
</script>
<style lang="scss">
.page-blocked {
    &__wrapper {
        background-color: #fff;
        height: 651px;
        border-radius: 10px !important;
        position: relative;
    }

    &__content {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;

        p {
            width: calc(100% - 60px);
            text-align: center;
            font-size: 18px;
            font-weight: 700;
            font-family: Montserrat, sans-serif;
            line-height: 21.94px;
        }

        img {
            margin-bottom: 34px;
        }
    }
}
</style>